/**
 * 予約販売カートバリデーション
 * 予約販売商品（在庫切れ継続販売）と通常商品の混在を検知し、
 * チェックアウトを無効化する。
 *
 * 定期購入商品のゲスト購入制限
 * 定期購入商品（subscription_flag）がカートにある場合、
 * 未ログインユーザーのチェックアウトを無効化する。
 *
 * 定期購入商品の合わせ買い制限
 * 定期購入商品と通常商品が混在する場合、チェックアウトを無効化する。
 */
(function () {
  'use strict';

  const WARNING_MESSAGE =
    '予約販売商品と通常商品は一緒にご購入いただけません。予約販売商品のみ、または通常商品のみでご注文ください。';

  const OVERSTOCK_MESSAGE =
    'カート内の商品数量が在庫数を超えています。数量を変更してからご注文ください。';

  const SUBSCRIPTION_LOGIN_MESSAGE =
    '定期購入商品のご購入には会員登録・ログインが必要です。';

  const CHECKOUT_LABEL_DEFAULT = null; // 初回取得時に保存
  const CHECKOUT_LABEL_GUEST = 'ゲスト購入';
  const VALIDATE_EVENT = 'cart:validate';
  const VALIDATE_HANDLER_KEY = '__cartPreorderValidationHandler';

  function getCheckoutButtons() {
    return [document.getElementById('checkout'), document.getElementById('CartDrawer-Checkout')].filter(Boolean);
  }

  function isCustomerLoggedIn() {
    const el = document.querySelector('[data-customer-logged-in]');
    if (!el) return true; // フォールバック: 要素がなければ制限しない
    return el.dataset.customerLoggedIn !== 'false';
  }

  function getCartState(allItems) {
    let subCount = 0;
    let preorderCount = 0;
    for (const item of allItems) {
      if (item.dataset.subscription === 'true') subCount++;
      if (item.dataset.preorder === 'true') preorderCount++;
    }
    const hasSub = subCount > 0;
    const mixedSub = hasSub && allItems.length > subCount;
    const mixed = preorderCount > 0 && allItems.length > preorderCount;
    return { hasSub, mixedSub, mixed };
  }

  function hasOverstockedItems() {
    let found = false;
    document.querySelectorAll('.quantity__input').forEach((input) => {
      const index = input.dataset.index;
      const inventoryQty = parseInt(input.dataset.inventoryQuantity, 10);
      const isOver = !isNaN(inventoryQty) && inventoryQty > 0 && parseInt(input.value, 10) > inventoryQty;

      const errorEl =
        document.getElementById(`Line-item-error-${index}`) ||
        document.getElementById(`CartDrawer-LineItemError-${index}`);
      if (errorEl) {
        const textEl = errorEl.querySelector('.cart-item__error-text');
        if (textEl) textEl.textContent = isOver ? `在庫数は${inventoryQty}個です。数量を変更してください。` : '';
      }

      if (isOver) found = true;
    });
    return found;
  }

  // 元のチェックアウトボタンラベルを保存
  const originalLabels = new Map();

  function validate() {
    const allItems = document.querySelectorAll('tr.cart-item:not(.cart-item__nested-line)');
    const { hasSub, mixedSub, mixed } = getCartState(allItems);
    const overstocked = hasOverstockedItems();
    const loggedIn = isCustomerLoggedIn();
    const isGuest = !loggedIn;
    const invalid = mixed || overstocked || (hasSub && isGuest) || mixedSub;

    // 予約販売・在庫超過の警告（定期購入混在時は予約販売警告を抑制）
    const showMixed = mixed && !mixedSub;
    document.querySelectorAll('[data-preorder-warning]').forEach((el) => {
      el.textContent = showMixed ? WARNING_MESSAGE : overstocked ? OVERSTOCK_MESSAGE : '';
      el.hidden = !(showMixed || overstocked);
    });

    // 定期購入ログイン必須の警告
    document.querySelectorAll('[data-subscription-warning]').forEach((el) => {
      el.textContent = hasSub && isGuest ? SUBSCRIPTION_LOGIN_MESSAGE : '';
      el.hidden = !(hasSub && isGuest);
    });

    // 定期購入合わせ買い不可の警告
    document.querySelectorAll('[data-subscription-mixed-warning]').forEach((el) => {
      el.textContent = mixedSub ? (el.dataset.message || '') : '';
      el.hidden = !mixedSub;
    });

    // 動的チェックアウトボタン（Apple Pay等）の表示制御
    // invalid(予約+通常混在/サブスクゲスト/サブスク混在/在庫超過)・空カートでは
    // 非表示にし、通常チェックアウトボタン無効化を express で回避されるのを防ぐ。
    document.querySelectorAll('[data-additional-checkout-buttons]').forEach((el) => {
      el.hidden = invalid || allItems.length === 0;
    });

    // チェックアウトボタンのラベル切替と無効化
    getCheckoutButtons().forEach((btn) => {
      if (!originalLabels.has(btn.id)) {
        originalLabels.set(btn.id, btn.textContent.trim());
      }

      // 未ログイン・定期購入なしのときは「ゲスト購入」に変更（有効のまま）
      btn.textContent = (isGuest && !hasSub) ? CHECKOUT_LABEL_GUEST : (originalLabels.get(btn.id) || btn.textContent);

      if (invalid) {
        btn.disabled = true;
      } else {
        const hasItems = allItems.length > 0;
        btn.disabled = !hasItems;
      }
    });

    // 未ログイン時に「ログインして購入」ボタンを表示
    document.querySelectorAll('[data-subscription-login-button]').forEach((el) => {
      el.hidden = !isGuest;
    });
  }

  function init() {
    validate();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // DOM 更新後に実行するため setTimeout を使う
        setTimeout(validate, 0);
      });
    }

    if (document[VALIDATE_HANDLER_KEY]) {
      document.removeEventListener(VALIDATE_EVENT, document[VALIDATE_HANDLER_KEY]);
    }
    document[VALIDATE_HANDLER_KEY] = validate;
    document.addEventListener(VALIDATE_EVENT, validate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
